import createIcon from '../../createIcon';

/**
 * @component @name SportsBasketball
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMDg5OCAxMS4wMDA4SDIxLjk0OThDMjEuNzg5OCA5LjM5MDc4IDIxLjIzOTggNy44OTA3OCAyMC40MDk4IDYuNjAwNzhDMTguNjc5OCA3LjQzMDc4IDE3LjQxOTggOS4wNTA3OCAxNy4wODk4IDExLjAwMDhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNi45MDk4IDExLjAwMDhDNi41Nzk4IDkuMDUwNzggNS4zMTk4IDcuNDMwNzggMy41ODk4IDYuNjAwNzhDMi43NTk4IDcuODkwNzggMi4yMDk4IDkuMzkwNzggMi4wNDk4IDExLjAwMDhINi45MDk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjA2OTggMTEuMDAwOEMxNS4zODk4IDguNDEwNzggMTYuOTQ5OCA2LjIxMDc4IDE5LjEyOTggNS4wMDA3OEMxNy41Mjk4IDMuMzcwNzggMTUuMzg5OCAyLjI5MDc4IDEyLjk5OTggMi4wNTA3OFYxMS4wMDA4SDE1LjA2OThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC45Mjk4IDExLjAwMDhIMTAuOTk5OFYyLjA1MDc4QzguNjA5OCAyLjI5MDc4IDYuNDU5OCAzLjM3MDc4IDQuODY5OCA1LjAwMDc4QzcuMDQ5OCA2LjIxMDc4IDguNjA5OCA4LjQxMDc4IDguOTI5OCAxMS4wMDA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjA2OTggMTMuMDAwOEgxMi45OTk4VjIxLjk1MDhDMTUuMzg5OCAyMS43MTA4IDE3LjUzOTggMjAuNjMwOCAxOS4xMjk4IDE5LjAwMDhDMTYuOTQ5OCAxNy43OTA4IDE1LjM4OTggMTUuNTkwOCAxNS4wNjk4IDEzLjAwMDhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41ODk4IDE3LjQwMDhDNS4zMDk4IDE2LjU3MDggNi41Nzk4IDE0Ljk0MDggNi45MDk4IDEzLjAwMDhIMi4wNDk4QzIuMjA5OCAxNC42MTA4IDIuNzU5OCAxNi4xMTA4IDMuNTg5OCAxNy40MDA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjA4OTggMTMuMDAwOEMxNy40MTk4IDE0Ljk1MDggMTguNjc5OCAxNi41NzA4IDIwLjQwOTggMTcuNDAwOEMyMS4yMzk4IDE2LjExMDggMjEuNzg5OCAxNC42MTA4IDIxLjk0OTggMTMuMDAwOEgxNy4wODk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguOTI5OCAxMy4wMDA4QzguNjA5OCAxNS41OTA4IDcuMDQ5OCAxNy43OTA4IDQuODY5OCAxOS4wMDA4QzYuNDY5OCAyMC42MzA4IDguNjA5OCAyMS43MTA4IDEwLjk5OTggMjEuOTUwOFYxMy4wMDA4SDguOTI5OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsBasketball = createIcon('SportsBasketball', [
  [
    'path',
    {
      d: 'M17.0898 11.0008H21.9498C21.7898 9.39078 21.2398 7.89078 20.4098 6.60078C18.6798 7.43078 17.4198 9.05078 17.0898 11.0008Z',
      key: 'ki07y',
    },
  ],
  [
    'path',
    {
      d: 'M6.9098 11.0008C6.5798 9.05078 5.3198 7.43078 3.5898 6.60078C2.7598 7.89078 2.2098 9.39078 2.0498 11.0008H6.9098Z',
      key: '1jrme9',
    },
  ],
  [
    'path',
    {
      d: 'M15.0698 11.0008C15.3898 8.41078 16.9498 6.21078 19.1298 5.00078C17.5298 3.37078 15.3898 2.29078 12.9998 2.05078V11.0008H15.0698Z',
      key: '13alme',
    },
  ],
  [
    'path',
    {
      d: 'M8.9298 11.0008H10.9998V2.05078C8.6098 2.29078 6.4598 3.37078 4.8698 5.00078C7.0498 6.21078 8.6098 8.41078 8.9298 11.0008Z',
      key: 'd9ybx2',
    },
  ],
  [
    'path',
    {
      d: 'M15.0698 13.0008H12.9998V21.9508C15.3898 21.7108 17.5398 20.6308 19.1298 19.0008C16.9498 17.7908 15.3898 15.5908 15.0698 13.0008Z',
      key: 'q8g816',
    },
  ],
  [
    'path',
    {
      d: 'M3.5898 17.4008C5.3098 16.5708 6.5798 14.9408 6.9098 13.0008H2.0498C2.2098 14.6108 2.7598 16.1108 3.5898 17.4008Z',
      key: '1g5oa9',
    },
  ],
  [
    'path',
    {
      d: 'M17.0898 13.0008C17.4198 14.9508 18.6798 16.5708 20.4098 17.4008C21.2398 16.1108 21.7898 14.6108 21.9498 13.0008H17.0898Z',
      key: 'd7gv17',
    },
  ],
  [
    'path',
    {
      d: 'M8.9298 13.0008C8.6098 15.5908 7.0498 17.7908 4.8698 19.0008C6.4698 20.6308 8.6098 21.7108 10.9998 21.9508V13.0008H8.9298Z',
      key: 'o30wr8',
    },
  ],
]);

export default SportsBasketball;
